// extracted by mini-css-extract-plugin
export default {"description":"LandingSectionHeader_description__JYp0i","header":"LandingSectionHeader_header__4kwYF"};